var React = require('react');

function IconQuestionCircle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"An icon of a black question mark inside a circle that indicates more information."),React.createElement("path",{"d":"M9.46,5c0,1.83-2,1.86-2,2.54v.17a.33.33,0,0,1-.33.33H5.9a.33.33,0,0,1-.33-.33V7.5c0-1,.74-1.37,1.3-1.68s.77-.45.77-.81S7,4.22,6.56,4.22s-.93.3-1.34.82a.33.33,0,0,1-.46.06L4,4.52a.33.33,0,0,1-.07-.45A3.07,3.07,0,0,1,6.68,2.59,2.72,2.72,0,0,1,9.46,5ZM7.67,9.59A1.15,1.15,0,1,1,6.52,8.44,1.15,1.15,0,0,1,7.67,9.59Z","transform":"translate(-0.1 -0.1)","key":1}),React.createElement("circle",{"cx":"6.56","cy":"6.56","r":"6.06","style":{"fill":"none","stroke":"currentColor","strokeMiterlimit":"10"},"key":2})]);
}

IconQuestionCircle.defaultProps = {"className":"icon icon-middle icon-question","viewBox":"0 0 14 14"};

module.exports = IconQuestionCircle;

IconQuestionCircle.default = IconQuestionCircle;
